import {postMethod} from '~/api'

async function post(formData) {
    return await postMethod('/api/import/organisations', formData, {'Content-Type': 'multipart/form-data'})
}

export {post}
